import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getTeams = actionFactory(types.GET_TEAMS);
